
export function guessAgeTypeLabel(birthdayISO) {
  if (!birthdayISO) return "";

  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();
  const pivotYear = (month < 3 || (month === 3 && day < 15)) ? year - 1 : year;
  const pivot = new Date(pivotYear, 2, 15);

  const [birthYear, birthMonth, birthDay] = birthdayISO.split("-").map(Number);
  const birthday = new Date(birthYear, birthMonth - 1, birthDay);
  if (Number.isNaN(birthday.getTime())) return "";

  let age = pivot.getFullYear() - birthday.getFullYear();
  const monthDiff = pivot.getMonth() - birthday.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && pivot.getDate() < birthday.getDate())) {
    age--;
  }

  if (age <= 5) return "Exentos (0-5) -> 0";
  if (age <= 13) return "Infantiles (6-13) -> 1";
  if (age <= 17) return "Juveniles (14-17) -> 2";
  return "Adultos (18+) -> 3";
}